import Axios from "axios";
import { redirectToLoginAfterUnauthorized } from "./authRedirect";

let interceptorId: number | null = null;

export const setupAxiosUnauthorizedRedirect = () => {
  if (interceptorId != null) {
    return;
  }

  interceptorId = Axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const isTerminatedUser = error?.response?.data?.code === "USER_TERMINATED";

      if (error?.response?.status === 401 && !isTerminatedUser) {
        redirectToLoginAfterUnauthorized();
      }

      return Promise.reject(error);
    },
  );
};
